export const getters = {
    list: state => state.list,
    inventory: state => state.inventory,
    columns: state => state.columns,
    model: state => state.model,
    filter: state => state.filter,
    pagination: state => state.pagination,
    pagination_patients: state => state.pagination_patients,
    sort: state => state.sort,
    rules: state => state.rules,
};
